import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = [
    'checkbox',
    'hiddenBulkDeleteValue',
    'hiddenSelectionMode',
    'hiddenSelectedItems',
    'bulkDeleteButton',
    'editDatesButton'
  ];

  static outlets = ['components--admin-data-table'];

  static values = {
    programId: String,
    filterParams: Object
  }

  connect() {
    this.activeUserIds = new Set();
    this.inactiveUserIds = new Set();
    this.selectionMode = 'none';

    document.addEventListener('promote:data-table:selection', this.setActiveValue.bind(this));
    document.addEventListener('promote:confirm-cancel', this.uncheckMember.bind(this));
  }

  disconnect() {
    document.removeEventListener('promote:data-table:selection', this.setActiveValue.bind(this));
    document.removeEventListener('promote:confirm-cancel', this.uncheckMember.bind(this));
  }

  setActiveValue(event) {
    const { selectionMode, selectedItems } = event.detail;

    this.selectionMode = selectionMode;
    this.activeUserIds.clear();
    this.inactiveUserIds.clear();

    if (selectionMode === 'all' || selectionMode === 'all_except') {
      this._excludedItems = selectionMode === 'all_except'
        ? [...selectedItems.values()]
        : [];
    } else {
      this._excludedItems = [];

      let items = [...selectedItems.values()];

      this.activeUserIds = new Set(
        items
          .filter(entry => entry.dataset.hasInteractions === "true")
          .map(entry => entry.id)
      );

      this.inactiveUserIds = new Set(
        items
          .filter(entry => entry.dataset.hasInteractions !== "true")
          .map(entry => entry.id)
      );
    }

    this._updateBulkDeleteButton();
    this._toggleEditDatesButton();
  }

  _updateBulkDeleteButton() {
    if (this.selectionMode === 'all' || this.selectionMode === 'all_except') {
      this._setDeleteHiddenFields();
      this.bulkDeleteButtonTarget.disabled = false;
    } else if (this.activeUserIds.size > 0) {
      this.bulkDeleteButtonTarget.disabled = true;
    } else if (this.inactiveUserIds.size > 0) {
      this.hiddenBulkDeleteValueTarget.value = Array.from(this.inactiveUserIds).join(',');
      this._clearSelectionModeFields();
      this.bulkDeleteButtonTarget.disabled = false;
    } else {
      this.bulkDeleteButtonTarget.disabled = true;
    }
  }

  _setDeleteHiddenFields() {
    if (this.hasHiddenSelectionModeTarget) {
      this.hiddenSelectionModeTarget.value = this.selectionMode;
    }

    if (this.hasHiddenSelectedItemsTarget) {
      const excludedIds = this._excludedItems.map(item => item.id).join(',');
      this.hiddenSelectedItemsTarget.value = excludedIds;
    }

    this.hiddenBulkDeleteValueTarget.value = '';
  }

  _clearSelectionModeFields() {
    if (this.hasHiddenSelectionModeTarget) {
      this.hiddenSelectionModeTarget.value = '';
    }

    if (this.hasHiddenSelectedItemsTarget) {
      this.hiddenSelectedItemsTarget.value = '';
    }
  }

  _toggleEditDatesButton() {
    if (!this.hasEditDatesButtonTarget) {
      return;
    }

    const hasSelection = this.selectionMode === 'all' ||
      this.selectionMode === 'all_except' ||
      this.activeUserIds.size > 0 ||
      this.inactiveUserIds.size > 0;

    this.editDatesButtonTarget.disabled = !hasSelection;
  }

  checkMember(event) {
    this.activeUserIds.clear();
    this.inactiveUserIds.clear();

    document.dispatchEvent(
      new CustomEvent('promote:data-table:clear-selection', { detail: {} })
    );

    const currentCheckbox = event.target.closest('.js-table-body-row')
      .querySelector('input[type="checkbox"]');

    currentCheckbox.click();
  }

  uncheckMember(event) {
    let rowElement = event.detail.element.closest('.js-table-body-row');

    if (!rowElement) return;

    let checkbox = rowElement.querySelector('input[type="checkbox"]');

    if (checkbox.checked) { checkbox.click(); };
  }

  openEditDatesForm() {
    if (this.ajaxRequest) {
      this.ajaxRequest.abort();
    }

    const params = new URLSearchParams();

    if (this.selectionMode === 'all') {
      params.set('selection_mode', 'all');
    } else if (this.selectionMode === 'all_except') {
      params.set('selection_mode', 'all_except');
      this._excludedItems.forEach(item => params.append('selected_items[]', item.id));
    } else {
      const combinedSet = new Set([...this.activeUserIds, ...this.inactiveUserIds]);
      combinedSet.forEach(id => params.append('user_ids[]', id));
    }

    const url = `/admin/programs/${this.programIdValue}/members/edit_dates?${params.toString()}`;

    Rails.ajax({
      url: url,
      type: 'GET',
      dataType: 'script',
      beforeSend: (xhr) => {
        this.ajaxRequest = xhr;
        return true;
      }
    })
  }
}
